/**
 * POST `admin/clients/:id/doctors` — добавить врача админ-сайдом.
 * Специализация обязательна; UI держит имя — в id переводит справочник.
 */

import {apiEnabled, http} from '@services/utils';
import {toE164} from '@utils/phone';

import {buildClientDetail, patchDetailMock} from '../detailMocks';
import {getSpecializations} from '../getSpecializations';
import {MOCK_CLIENTS} from '../mocks';

export type AddDoctorInput = {
  clientId: string;
  fullName: string;
  phone: string;
  /** Имя специализации из справочника */
  specialization: string;
};

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const addDoctor = async (input: AddDoctorInput): Promise<{ok: true}> => {
  if (!apiEnabled) {
    await sleep(300);
    const row = MOCK_CLIENTS.find((c) => c.id === input.clientId);
    if (row) {
      const staff = buildClientDetail(row).staff;
      patchDetailMock(input.clientId, {
        staff: [
          ...staff,
          {
            id: `${input.clientId}-doc-${Date.now()}`,
            accountId: `${input.clientId}-acc-${Date.now()}`,
            fullName: input.fullName.trim(),
            phone: `+996 ${input.phone}`,
            role: 'doctor',
            specialization: input.specialization,
            active: true,
            blocked: false,
          },
        ],
      });
      row.seatsUsed += 1;
    }
    return {ok: true};
  }

  const specializationId =
    (await getSpecializations()).find((s) => s.name === input.specialization)?.id ?? '';
  await http(`admin/clients/${encodeURIComponent(input.clientId)}/doctors`, {
    method: 'POST',
    body: {
      fullName: input.fullName.trim(),
      phone: toE164(input.phone),
      specializationId,
    },
    skipCaseConversion: true,
  });
  return {ok: true};
};
